export default "__VITE_ASSET__wjz$qIph__"